import { BaseMutations } from '@/store/base-mutations';
import { DataPilot } from '@/modules/data-pilot/types';
import { EventHistoryState } from './state';

export default class EventHistoryMutations extends BaseMutations<EventHistoryState> {
  SET_EVENTS(events: DataPilot.Event[]) {
    this.state.events = events;
  }

  TOGGLE_LOADING(toggle: boolean) {
    this.state.loading = toggle;
  }

  SET_COMMENTS(comments: string[]) {
    this.state.comments = comments;
  }
}
